import { LoginForm } from "~/features/auth/components/login-form";

export function LoginPage() {
  return <LoginForm />;
}
